export const ErrorCodeDefinitions = [
	{
		Code: 'LH',
		IP: '10.24.38.124',
		Domain: 'SWIMS0HY5001.acct.upmchs.net',
	},
	{
		Code: 'MI',
		IP: '10.24.39.71',
		Domain: 'SWIMS0HY5002.acct.upmchs.net',
	},
	{
		Code: 'MJ',
		IP: '10.24.39.72',
		Domain: 'SWIMS0HY5003.acct.upmchs.net',
	},
	{
		Code: 'MK',
		IP: '10.24.39.118',
		Domain: 'SWIMS0AP5001',
	},
	{
		Code: 'ML',
		IP: '10.24.39.119',
		Domain: 'SWIMS0WB5001',
	},
	{
		Code: 'KJ',
		IP: '10.24.39.118',
		Domain: 'SWIMS0AP5002',
	},
	{
		Code: 'KK',
		IP: '10.24.39.119',
		Domain: 'SWIMS0WB5002',
	},
	{
		Code: 'HD',
		IP: '10.35.25.30',
		Domain: 'swims0ap4006.upmceu.net',
	},
	{
		Code: 'HI',
		IP: '10.24.70.53',
		Domain: 'SWIMS0AP4007.acct.upmchs.net',
	},
	{
		Code: 'GJ',
		IP: '10.24.45.12',
		Domain: 'swims0ap4010.smgt.upmc.edu',
	},
	{
		Code: 'GK',
		IP: '10.24.45.13',
		Domain: 'swims0ap4011.SMGT.upmc.edu',
	},
	{
		Code: 'GJ',
		IP: '10.24.132.180',
		Domain: 'swims0ap4012.SMGT.upmc.edu',
	},
	{
		Code: 'JI',
		IP: '10.24.51.23',
		Domain: 'SWCHIEAP4004.SMGT.upmc.edu',
	},
	{
		Code: 'PS',
		IP: '10.25.87.198',
		Domain: 'WINIMSNSTST001.acct.upmchs.net',
	},
	{
		Code: 'PT',
		IP: '10.25.87.199',
		Domain: 'WINIMSNSTST002.acct.upmchs.net',
	},
	{
		Code: 'LH',
		IP: '10.24.38.205',
		Domain: 'SWIMS0WB4003.acct.upmchs.net',
	},
	{
		Code: 'LI',
		IP: '10.24.38.206',
		Domain: 'SWIMS0WB4004.acct.upmchs.net',
	},
	{
		Code: 'CB',
		IP: '10.24.110.10',
		Domain: 'SWIMS0WB4005.acct.upmchs.net',
	},
	{
		Code: 'JN',
		IP: '10.24.44.53',
		Domain: 'swims0wb4006.smgt.upmc.edu',
	},
	{
		Code: 'JO',
		IP: '10.24.44.56',
		Domain: 'swims0wb4007.smgt.upmc.edu',
	},
	{
		Code: 'JG',
		IP: '10.24.44.54',
		Domain: 'swims0wb4008.smgt.upmc.edu',
	},
	{
		Code: 'KM',
		IP: '10.24.45.167',
		Domain: 'SWENTRAP4003.smgt.upmc.edu',
	},
	{
		Code: 'KN',
		IP: '10.24.45.168',
		Domain: 'SWENTRAP4004.smgt.upmc.edu',
	},
	{
		Code: 'MN',
		IP: '10.25.138.229',
		Domain: 'winimssstst16.acct.upmchs.net',
	},
	{
		Code: 'MP',
		IP: '10.24.39.96',
		Domain: 'swims0db4002',
	},
	{
		Code: 'OQ',
		IP: '10.25.176.97',
		Domain: 'swims0ap4002.ims-test.upmc.edu',
	},
	{
		Code: 'OR',
		IP: '10.25.176.98',
		Domain: 'swims0ap4003.ims-test.upmc.edu',
	},
	{
		Code: 'HK',
		IP: '10.24.70.190',
		Domain: 'swims0ap4009.ims-test.upmc.edu',
	},
	{
		Code: 'HI',
		IP: '10.35.25.26',
		Domain: 'Swims0ap1002.upmceu.net      ',
	},
	{
		Code: 'GK',
		IP: '10.89.132.226',
		Domain: 'SWIMS0AP1003.SMGT.upmc.edu',
	},
	{
		Code: 'HI',
		IP: '10.92.231.105',
		Domain: 'SWIMS0AP1004.SMGT.upmc.edu',
	},
	{
		Code: 'IF',
		IP: '10.92.254.48',
		Domain: 'swims0ap1008.SMGT.upmc.edu',
	},
	{
		Code: 'IG',
		IP: '10.92.254.49',
		Domain: 'swims0ap1009.SMGT.upmc.edu',
	},
	{
		Code: 'IQ',
		IP: '10.92.254.56',
		Domain: 'swims0ap1010.SMGT.upmc.edu',
	},
	{
		Code: 'KG',
		IP: '10.92.103.18',
		Domain: 'swims0ap1012.SMGT.upmc.edu',
	},
	{
		Code: 'ME',
		IP: '10.92.115.14',
		Domain: 'SWCHIEAP1008.SMGT.upmc.edu ',
	},
	{
		Code: 'NH',
		IP: '10.25.139.223',
		Domain: 'WINIMSNSPRD04',
	},
	{
		Code: 'NI',
		IP: '10.25.139.224',
		Domain: 'WINIMSNSPRD05',
	},
	{
		Code: 'NK',
		IP: '10.25.139.226',
		Domain: 'WINIMSNSPRD06',
	},
	{
		Code: 'KM',
		IP: '10.88.172.129',
		Domain: 'swims0wb6001.acct.upmchs.net',
	},
	{
		Code: 'IC',
		IP: '10.92.230.44',
		Domain: 'SWIMS0WB1012.SMGT.upmc.edu',
	},
	{
		Code: 'II',
		IP: '10.92.230.45',
		Domain: 'SWIMS0WB1013.SMGT.upmc.edu',
	},
	{
		Code: 'IL',
		IP: '10.92.230.46',
		Domain: 'SWIMS0WB1014.SMGT.upmc.edu',
	},
	{
		Code: 'IF',
		IP: '10.89.134.113',
		Domain: 'SWIMS0WB1009.SMGT.upmc.edu',
	},
	{
		Code: 'HM',
		IP: '10.89.124.255',
		Domain: 'SWIMS0WB1010.SMGT.upmc.edu',
	},
	{
		Code: 'IA',
		IP: '10.89.125.0',
		Domain: 'SWIMS0WB1011.SMGT.upmc.edu',
	},
	{
		Code: 'MC',
		IP: '10.92.102.43',
		Domain: 'swims0wb1015.smgt.upmc.edu',
	},
	{
		Code: 'HD',
		IP: '10.92.230.12',
		Domain: 'swims0wb1016.smgt.upmc.edu',
	},
	{
		Code: 'HH',
		IP: '10.92.232.124',
		Domain: 'swims0db1003',
	},
	{
		Code: 'HI',
		IP: '10.92.232.125',
		Domain: 'swims0db1004',
	},
	{
		Code: 'HG',
		IP: '10.92.232.123',
		Domain: 'swims0db1002',
	},
	{
		Code: 'JG',
		IP: '10.27.72.15',
		Domain: 'swims0db6001',
	},
	{
		Code: 'LH',
		IP: '10.24.38.43',
		Domain: 'SWIMS0DB5001.acct.upmchs.net',
	},
	{
		Code: 'LI',
		IP: '10.24.38.44',
		Domain: 'SWIMS0DB5002.acct.upmchs.net',
	},
	{
		Code: 'IM',
		IP: '10.92.254.158',
		Domain: 'SWENTRAP1004.smgt.upmc.edu',
	},
	{
		Code: 'LN',
		IP: '10.27.71.87',
		Domain: 'SWENTRAP6002.smgt.upmc.edu',
	},
	{
		Code: 'NM',
		IP: '10.25.139.228',
		Domain: 'winimsnsdr01',
	},
	{
		Code: 'GH',
		IP: '10.24.132.16',
		Domain: 'SWIMS0AP6001.SMGT.upmc.edu',
	},
	{
		Code: 'IC',
		IP: '10.27.71.60',
		Domain: 'swims0ap6002.SMGT.upmc.edu',
	},
	{
		Code: 'LP',
		IP: '10.92.102.22',
		Domain: 'swims0wb6003.SMGT.upmc.edu',
	},
	{
		Code: 'JH',
		IP: '10.27.70.32',
		Domain: 'swims0wb6004.SMGT.upmc.edu',
	},
	{
		Code: 'OK',
		IP: '10.25.68.28',
		Domain: 'WINIMSNSPRD15.INFOSEC.UPMC.EDU',
	},
	{
		Code: 'OL',
		IP: '10.25.68.29',
		Domain: 'WINIMSNSPRD16.INFOSEC.UPMC.EDU',
	},
	{
		Code: 'OF',
		IP: '10.25.68.32',
		Domain: 'WINIMSNSPRD17.INFOSEC.UPMC.EDU',
	},
	{
		Code: 'JH',
		IP: '10.92.254.18',
		Domain: 'SWIMS0AP1005.SMGT.UPMC.EDU',
	},
	{
		Code: 'JI',
		IP: '10.92.254.19',
		Domain: 'SWIMS0AP1006.SMGT.UPMC.EDU',
	},
	{
		Code: 'II',
		IP: '10.92.254.57',
		Domain: 'SWIMS0AP1011.SMGT.upmc.edu',
	},
	{
		Code: 'JJ',
		IP: '10.92.254.20',
		Domain: 'swims0ap1007.smgt.upmc.edu',
	},
];
